import * as React from "react";
const SvgFiRrKissWinkHeart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-kiss-wink-heart_svg__a)">
      <path
        fill="#062147"
        d="M23.867 19.964c-.537 1.514-3.066 2.56-4.292 2.988a.875.875 0 0 1-1.045-.4c-.666-1.151-1.938-3.651-1.4-5.166a1.876 1.876 0 0 1 2.366-1.28 1.99 1.99 0 0 1 1 2.569 1.876 1.876 0 0 1 2.366-1.281 1.994 1.994 0 0 1 1.005 2.57m-8.935 1.6a10 10 0 1 1 6.8-7.267 1 1 0 0 0 1.948.457A12.001 12.001 0 1 0 0 12a12.06 12.06 0 0 0 15.518 11.476 1 1 0 1 0-.586-1.912M18 10a2 2 0 1 0-4 0c0 1 .895 1 2 1s2 0 2-1m-7 0a1 1 0 0 0-1-1H7a1 1 0 0 0 0 2h3a1 1 0 0 0 1-1m4 4.5a2.5 2.5 0 0 0-2.5-2.5h-1.731a1 1 0 0 0 0 2H12.5a.5.5 0 0 1 0 1H12a1 1 0 0 0 0 2h.5a.5.5 0 0 1 0 1h-1.731a1 1 0 0 0 0 2H12.5a2.506 2.506 0 0 0 1.987-4A2.47 2.47 0 0 0 15 14.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-kiss-wink-heart_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrKissWinkHeart;
